import { Link, Popover } from '@amzn/awsui-components-react'
import React from 'react'
import { getRuleGroupPageUrl } from '../../backend/internalUrls'

interface InheritedPropertyPopoverProps {
  parentRuleGroup: string
}

export const InheritedPropertyPopover: React.FC<InheritedPropertyPopoverProps> = ({parentRuleGroup, children}) => {
  const INHERITED_PROPERTY_MESSAGE = <span>
    Inherited from: <Link href={getRuleGroupPageUrl(parentRuleGroup)}>{parentRuleGroup}</Link>
  </span>

  return (
    <span>
      {children} <Popover content={INHERITED_PROPERTY_MESSAGE}>[*]</Popover>
    </span>
  )
}